import { StateStatus } from '../../../../shared/infrastructure/store/utils/state_status';
import { BusinessType } from '../../models/business_type.model';
import BaseBusinessTypeState from './state.interface';

export class BusinessTypeState {
    constructor(state: BaseBusinessTypeState) {
        const { status, liveBusinessType, errorMessage } = state;

        this.status = status ?? StateStatus.initial;
        this.liveBusinessType = liveBusinessType ?? [];
        this.errorMessage = errorMessage ?? undefined;
    }

    status?: StateStatus;
    liveBusinessType?: BusinessType[];
    errorMessage?: string;

    copyWith(state: BaseBusinessTypeState) {
        const { status, liveBusinessType, errorMessage } = state;

        return new BusinessTypeState({
            status: status !== undefined ? status : this.status,
            liveBusinessType: liveBusinessType !== undefined ? liveBusinessType : this.liveBusinessType,
            errorMessage: errorMessage !== undefined ? errorMessage : this.errorMessage,
        });  
    }
}

